import { useContext } from 'react'
import { ScheduleContext } from './ScheduleContext'

export const useActivePractitioner = () => {
  const context = useContext(ScheduleContext)
  if (!context) {
    throw new Error('useActivePractitioner must be used within an ActivePractitionerProvider')
  }
  return context
}
